module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"action":{"refresh":"Obnovit seznam"}},"de":{"action":{"refresh":"Liste aktualisieren"}},"es":{"action":{"refresh":"Refresque la lista"}},"fr":{"action":{"refresh":"Rafraîchir la liste"}}}')
  delete Component.options._Ctor
}
